import { RefundModel } from 'api-hooks/refund/refund';
import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import {
  CardSection,
  FullContainer,
  Row,
  SeparatorVertical,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import AddonsCruiseTable from './addons-cruise';
import GuestCruiseTable from './guest-cruise';
import InformationCruiseTable from './information-cruise';

interface Props {
  refund?: RefundModel;
}

export default function CruisePurchaseSection(props: Props) {
  const { control } = useFormContext();
  const name = 'cruisePurchases';
  const { fields } = useFieldArray({
    control,
    name,
    keyName: 'customId',
  });

  const { t } = useTranslation();

  if (fields.length === 0) {
    return null;
  }

  return (
    <>
      <Separator gap={24} />
      {fields.map((field, index) => {
        return (
          <React.Fragment key={field.customId}>
            <CardSection>
              <FullContainer>
                <Row>
                  <Text $style={{ flex: 1 }} variant="HeadingXSmall">
                    {t('ticketSales:cruise_detail')} {index + 1}
                  </Text>
                </Row>
                <Separator gap={24} />
                <InformationCruiseTable />
                <Separator gap={24} />
                <GuestCruiseTable refund={props.refund} parentIndex={index} />
                <Separator gap={24} />
                <AddonsCruiseTable refund={props.refund} parentIndex={index} />
              </FullContainer>
            </CardSection>
            <SeparatorVertical $margin={32} />
          </React.Fragment>
        );
      })}
    </>
  );
}
